import { MessageServiceContext, Trans } from "@citychallenge/core";
import { observer } from "mobx-react";
import { FC, useContext } from "react";

import styles from "./message-display.module.scss";

export interface MesssageDisplayProps {}

export const MesssageDisplay: FC<MesssageDisplayProps> = observer(() => {
  const { activeMessage, latestMessage, dismissActive } = useContext(
    MessageServiceContext
  );

  const key =
    typeof latestMessage?.message === "object"
      ? latestMessage.message.key
      : latestMessage?.message;

  return (
    <div
      className={styles.wrapper}
      data-active={!!activeMessage}
      onClick={dismissActive}
    >
      <div className={styles.message} data-type={latestMessage?.type}>
        <Trans key={key} values={latestMessage?.values}>
          {latestMessage?.message}
        </Trans>
      </div>
    </div>
  );
});
